import { useContextSelector } from "use-context-selector";
import { useToaster } from "ui-seeker/core";
import { getSubmit } from "ui-seeker/utils";
import { GLOBAL } from "app/@common/constants";
import { useState } from "react";
import { AppCalendarEventsContext } from "../../Providers";

export default function useAppCalendarEventsActions(date) {

        const events = useContextSelector(AppCalendarEventsContext, ({ state }) => state.eventsData)
        const updateEvents = useContextSelector(AppCalendarEventsContext, ({ updateState }) => updateState)
        const [ isOpen, setIsOpen ] = useState(false)
        const dayEvents = events.filter(a => date >= a.start_date && date <= a.end_date)
        const { showToaster } = useToaster()
        const deleteEvent = eventID => {
            showToaster.confirm(`Are you sure to delete this event?`, {
                onSuccess: () => {
                    updateEvents({ eventsData: events.filter(a => a.id_event !== eventID) })
                    getSubmit(`${GLOBAL.DELETE_EVENT}/${eventID}`, {})
                        .catch(err => {
                            console.log(err)
                            updateEvents({eventsData: events})
                        })
                },
                onCancel: () => {
                    showToaster.warning('Cancelled!')
                }
            })
        }

        return {
            dayEvents, isOpen, setIsOpen, events, deleteEvent
        }

}